// These values should always be falsey (or just plain false) to convey that they are OFF
// and do not change anything.
//
// In dev mode, they can be true, but in production they will always be false
import { DEBUGGING } from '../constants';

const DevtoolsFlags = {
  NETWORK_ALWAYS_ERROR: 0,
  POPINS_BREAKDOWN_FAKE_EMPTY_STATE: false
};

// If in DEBUG mode, return the real flag value - otherwise always mark as OFF
const fake = function (real) {
  if (DEBUGGING) {
    return real;
  } else {
    return false;
  }
};

// Setter - will always set the flag to false if it is ever called in production
// It should never be called in production.
const set = function (flagName, value) {
  if (DEBUGGING) {
    DevtoolsFlags[flagName] = value;
  } else {
    DevtoolsFlags[flagName] = false;
  }
};

export const Devtools = {
  isNetworkAlwaysError () {
    return fake(DevtoolsFlags.NETWORK_ALWAYS_ERROR);
  },
  setNetworkAlwaysError (value) {
    set('NETWORK_ALWAYS_ERROR', value);
  },
  isPopinsBreakdownEmpty () {
    return fake(DevtoolsFlags.POPINS_BREAKDOWN_FAKE_EMPTY_STATE);
  },
  setPopinsBreakdownEmpty (value) {
    set('POPINS_BREAKDOWN_FAKE_EMPTY_STATE', value);
  }
};

